import React from 'react';

const ByRoso: React.FC = () => {
  return (
    <div
      className="h-screen w-screen bg-cover bg-no-repeat bg-[position:13%_center] sm:bg-center"
      style={{ backgroundImage: "url('/byRoso.png')" }}
    >
      {/* The entire page is just this background image */}
    </div>
  );
};

export default ByRoso; 